import { forwardRef, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthContext, capitalize } from '@repo-level/core-front';

import { AuthButtons } from 'components/auth/AuthButtons';
import { MenuDesktop } from 'components/general/Menu/MenuDesktop';
import { ModalDefaultProps } from 'components/Modal';
import { ModalTemplate } from 'components/ModalTemplate';
import { PromoPanelsMobile } from 'components/general/Header/PromoPanels';
import { UserPanelMobile } from 'components/general/Header/UserPanel';

import { ScSlogan } from '../styled';
import { ScMenuModal, ScTabbarDashboard } from './styled';

export const TabbarMenuModal = forwardRef<HTMLDivElement, ModalDefaultProps>(
  ({ onClose }, ref) => {
    const { t } = useTranslation('glossary');

    const { isAuthenticated } = useContext(AuthContext);

    const promoPanelsMobile = <PromoPanelsMobile onLinkClick={onClose} />;

    return (
      <ModalTemplate
        ref={ref}
        onClose={onClose}
        title={capitalize(t('menu'))}
        settings={{
          type: 'mobile',
          mode: {
            type: 'bottom',
          },
          smallXPadding: true,
        }}
      >
        <ScMenuModal>
          <ScSlogan>{t('slogan')}</ScSlogan>
          {isAuthenticated ? (
            <ScTabbarDashboard>
              <UserPanelMobile />
              {promoPanelsMobile}
            </ScTabbarDashboard>
          ) : (
            <>
              <AuthButtons horizontal xLarge />
              {promoPanelsMobile}
            </>
          )}
          <MenuDesktop onClick={onClose} />
        </ScMenuModal>
      </ModalTemplate>
    );
  }
);
